var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm8.5 4.326c.012 4.224-3.784 7.659-8.478 7.674-4.695.013-8.51-3.4-8.521-7.623L1 14.371C.985 12.103 6.394 11 6.394 11c.074.003.169.006.28.008.821.512 1.79.808 2.826.808a5.332 5.332 0 0 0 2.822-.805c.166-.003.305-.007.407-.011 0 0 5.287 1.103 5.271 3.371",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.19b3abba9efd06491c93bc74bac5ba74.svg";
export { ForwardRef as ReactComponent };